module.exports = __webpack_public_path__ + "img/frame.7e4e37a4.png";